// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class ListView extends JQueryView {
  constructor() {
    super('.news');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.validateSearchForm();

    this.render();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
          cancelLabel: 'Clear',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'change', selector: '#search_start_at' })
  onChangeStartAt(event: any) {
    if ($(event.target).val().length > 0) {
      this.validateSearchForm();
    }
  }

  @on({ event: 'change', selector: '#search_end_at' })
  onChangeEndAt(event: any) {
    if ($(event.target).val().length > 0) {
      this.validateSearchForm();
    }
  }

  @on({ event: 'click', selector: 'li[data-href]' })
  click(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.open($(e.currentTarget).data('href'), '_blank');
  }

  validateSearchForm() {
    const start_at = $('#search_start_at').val();
    const end_at = $('#search_end_at').val();
    if (new Date(start_at) > new Date(end_at)) {
      $('.search_start_at').addClass('form-group-invalid');
      $('.search_end_at').addClass('form-group-invalid');
      $('.daterange-picker').addClass('is-invalid');
      if (!$('#datepicker-row').hasClass('inValid')) {
        $('#datepicker-row')
          .addClass('inValid')
          .append(
            '<small class="invalid-feedback">開始・終了年月日を正しく入力してください。</small>',
          );
      }
    } else {
      $('.search_start_at').removeClass('form-group-invalid');
      $('.search_end_at').removeClass('form-group-invalid');
      $('.daterange-picker').removeClass('is-invalid');
      $('#datepicker-row')
        .removeClass('inValid')
        .find('.invalid-feedback')
        .remove();
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
